const ALERT_ROWS = ['grid-alert-1', 'grid-alert-2', 'grid-alert-3'];
const LINK_ROWS = ['grid-link-1', 'grid-link-2', 'grid-link-3'];
const OVERVIEW_ROWS = [
  'grid-overview-1',
  'grid-overview-2',
  'grid-overview-3',
  'grid-overview-4',
];

const CheckboxPlaceholder = () => (
  <span
    className="placeholder rounded-1 flex-shrink-0"
    style={{ width: 16, height: 16 }}
  />
);

/** Layout-accurate View Grid header chrome — title, actions, alerts/links, overview. */
const ViewGridHeaderSkeleton = () => (
  <div className="placeholder-glow" aria-hidden="true">
    <div className="d-flex flex-column d-sm-block">
      <div className="float-sm-end ao_secondaryBtnGroup order-3 mt-2 mb-2">
        <div className="d-inline-flex align-items-center gap-2">
          <span
            className="placeholder rounded"
            style={{ width: 110, height: 36 }}
          />
          <span
            className="placeholder rounded"
            style={{ width: 100, height: 36 }}
          />
          <span
            className="placeholder rounded"
            style={{ width: 100, height: 36 }}
          />
        </div>
      </div>

      <h1 className="Garamond fw-semibold v3-heading mb-2">
        <span className="placeholder rounded col-5" style={{ height: '2rem' }} />
      </h1>

      <p className="ao_showSource mt-2 mb-0">
        <span className="placeholder rounded col-3" style={{ height: '0.9rem' }} />
      </p>
    </div>

    <div className="row gx-3">
      <div className="col-md-9 mt-3 d-flex">
        <div className="v3-report-content-card w-100">
          <div className="mb-3">
            <span
              className="placeholder rounded"
              style={{ width: 120, height: '1rem' }}
            />
          </div>
          {ALERT_ROWS.map((key) => (
            <div className="d-flex align-items-start gap-2 mb-2" key={key}>
              <CheckboxPlaceholder />
              <div className="flex-grow-1">
                <span className="placeholder rounded col-10 d-block mb-1" />
                <span
                  className="placeholder rounded col-3 d-block"
                  style={{ height: '0.75rem' }}
                />
              </div>
              <span
                className="placeholder rounded-circle flex-shrink-0"
                style={{ width: 18, height: 18 }}
              />
            </div>
          ))}
        </div>
      </div>
      <div className="col-md-3 mt-3 d-flex">
        <div className="v3-report-content-card w-100">
          <div className="mb-3">
            <span
              className="placeholder rounded"
              style={{ width: 100, height: '1rem' }}
            />
          </div>
          {LINK_ROWS.map((key) => (
            <div className="mb-2" key={key}>
              <span className="placeholder rounded col-11" />
            </div>
          ))}
        </div>
      </div>
    </div>

    <div id="overviewMainBox" className="v3-report-content-card mt-3">
      {OVERVIEW_ROWS.map((key) => (
        <div className="row align-items-start mb-2" key={key}>
          <div className="col-md-4">
            <span
              className="placeholder rounded col-6"
              style={{ height: '0.95rem' }}
            />
          </div>
          <div className="col-md-8">
            <span className="placeholder rounded col-11 mb-1 d-block" />
            <span className="placeholder rounded col-8 d-block" />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default ViewGridHeaderSkeleton;
